import { onMounted, onUnmounted, unref } from "vue"
import { registerPbisPointsRefreshHandler } from "@/helpers/behaviourPbisSocket.js"

/**
 * @param {unknown} rawStudentId
 * @returns {number | null}
 */
function resolveTargetStudentId(rawStudentId) {
  if (rawStudentId == null || rawStudentId === "") {
    return null
  }

  const parsed = Number(rawStudentId)
  return Number.isFinite(parsed) ? parsed : null
}

/**
 * Refreshes behaviour manage data when a PBIS points socket event is received.
 * @param {{
 *   refresh: () => void | Promise<void>,
 *   studentId?: import('vue').MaybeRef<number | string | null | undefined>,
 *   enabled?: import('vue').MaybeRef<boolean>
 * }} options
 */
export function usePbisPointsSocketRefresh({
  refresh,
  studentId = null,
  enabled = true
} = {}) {
  const shouldRefreshForStudentIds = (affectedStudentIds = []) => {
    if (!unref(enabled)) {
      return false
    }

    const targetStudentId = resolveTargetStudentId(unref(studentId))
    const normalizedStudentIds = Array.isArray(affectedStudentIds)
      ? affectedStudentIds
      : []

    if (
      targetStudentId != null &&
      normalizedStudentIds.length &&
      !normalizedStudentIds.includes(targetStudentId)
    ) {
      return false
    }

    return true
  }

  const runRefresh = (affectedStudentIds = []) => {
    if (!shouldRefreshForStudentIds(affectedStudentIds)) {
      return
    }

    refresh?.()
  }

  let unsubscribeHandler = null

  onMounted(() => {
    unsubscribeHandler = registerPbisPointsRefreshHandler(runRefresh)
  })

  onUnmounted(() => {
    unsubscribeHandler?.()
    unsubscribeHandler = null
  })
}
